import { useParams } from 'react-router-dom';

export const useServiceId = (): string | undefined => {
  const urlParams = useParams();
  return urlParams['*']?.split('/')[0];
};
